document.addEventListener("DOMContentLoaded", function () {
  //Main Nav toggle
  const nav = document.querySelector("#primary-nav");
  const header = document.querySelector(".header-wrapper");
  const opener = document.querySelector(".mobile-nav-opener");

  opener.addEventListener("click", function (event) {
    
    event.preventDefault();

    header.classList.toggle("nav-open");
    nav.classList.toggle("active");

  });

});

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $(document).foundation(); // Foundation JavaScript
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        $('.home-success-stories-slides').slick({
          infinite: true,
          cssEase: 'linear',
          autoplay: true,
          arrows: true,
          dots: false
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'team': {
      init: function() {
        
        $('.team-photo-wrapper').mouseenter(function() {
          var div = $(this);
          var images = div.find('.team-photo');
          var current = images.find('img').index(images.find('img.active'));
          console.log(current);
          var total = images.length;
          console.log(total);
          var index = 0;
          if(total > 0){
            var interval = setInterval(function(){
             console.log(images[index++]);
             if(index == total){
                clearInterval(interval);
             } else {
              div.find('.active').removeClass('active').next('img').addClass('active');
             }
            }, 180)
          }
        }).mouseleave(function() {
          var div = $(this);
          var images = div.find('.team-photo');
          var current = images.find('img').index(images.find('img.active'));
          console.log(current);
          var total = images.length;
          console.log(total);
          var index = 0;
          if(total > 0){
            var interval = setInterval(function(){
             console.log(images[index++]);
             if(index == total){
                clearInterval(interval);
             } else {
              div.find('.active').removeClass('active').prev('img').addClass('active');
             }
            }, 180)
          }
        });
      }
    },
    
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


/*

//
$('.gallery').each(function( index ) {
  var gallery = $(this).attr('id');
  var lightbox = $('#' + gallery + ' a').simpleLightbox({  options  });
});

// Simple Lightbox - Already Installed
var lightbox = $('.gallery-gallery a').simpleLightbox();
// Slick Slideshow - Already Installed
$('.home-slideshow').slick({
  infinite: true,
  cssEase: 'linear',
  autoplay: true,
  arrows: true,
  dots: true
});

startSlideshow(wrapper){var idx=wrapper.attr('data-id');var images=wrapper.find('.images');var current_idx=images.find('img').index(images.find('img.active-image'));var total_images=images.find('img').length;if(images_interval[idx]){clearInterval(images_interval[idx]);}
images_interval[idx]=setInterval(function(){current_idx++;if(current_idx===total_images){if(images_interval[idx]){clearInterval(images_interval[idx]);}}
else{images.find('img.active-image').removeClass('active-image').next('img').addClass('active-image');}},100);}

function endSlideshow(wrapper){var idx=wrapper.attr('data-id');var images=wrapper.find('.images');var current_idx=images.find('img').index(images.find('img.active-image'));if(images_interval[idx]){clearInterval(images_interval[idx]);}
images_interval[idx]=setInterval(function(){if(current_idx===0){if(images_interval[idx]){clearInterval(images_interval[idx]);}}
else{current_idx--;images.find('img.active-image').removeClass('active-image').prev('img').addClass('active-image');}},100);}

*/